module.exports = __webpack_public_path__ + "media/images/emblems/Bioley-Magnoux-coat_of_arms-445310e292dba6fa4a6c8c1306f21b50.svg";